export default __webpack_public_path__ + "static/media/wot_egwene.c394ef2c.jpg";